import React from 'react'
import { Layout, Menu, Drawer } from 'antd'
import { NavLink, useLocation } from 'react-router-dom'

import {
  UserOutlined,
  CalendarOutlined,
  DashboardOutlined,
  CrownOutlined,
  HddOutlined
} from '@ant-design/icons'
import { RiArticleLine } from 'react-icons/ri'
import { ImBooks } from 'react-icons/im'
import Logo from '../Logo'

const navLinks = [
  { key: '/app/dashboard', icon: <DashboardOutlined />, to: '/app/dashboard', label: 'Dashboard' },
  { key: '/app/courses', icon: <ImBooks />, to: '/app/courses', label: 'Courses' },
  { key: '/app/calendar', icon: <CalendarOutlined />, to: '/app/calendar', label: 'Calendar' },
  { key: '/app/articles', icon: <RiArticleLine />, to: '/app/articles', label: 'Articles' },
  { key: '/app/acheivements', icon: <CrownOutlined />, to: '/app/acheivements', label: 'Achievements' },
  { key: '/app/archives', icon: <HddOutlined />, to: '/app/archives', label: 'Archives' },
  { key: '/app/profile', icon: <UserOutlined />, to: '/app/profile', label: 'Profile' }
]

const SideNav = (props) => {
  const { collapsed, onCollapse, isMobile, mobileOpen, onMobileClose } = props
  const { Sider } = Layout

  let currentPath = useLocation().pathname
  if (currentPath.includes('/app/course/'))
    currentPath = currentPath.replace('/app/course/', '/app/courses/')

  const menuContent = (
    <>
      <div
        style={{
          cursor: 'pointer',
          padding: collapsed && !isMobile ? '16px 8px' : '16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          background: 'hsl(210, 55%, 22%)'
        }}
        onClick={() => {
          if (isMobile) onMobileClose()
          window.location = '/'
        }}
      >
        <Logo collapsed={isMobile ? false : collapsed} />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[currentPath]}
        style={{ background: 'transparent', border: 'none' }}
        onClick={() => isMobile && onMobileClose()}
      >
        {navLinks.map(({ key, icon, to, label }) => (
          <Menu.Item key={key} icon={icon}>
            <NavLink to={to}>{label}</NavLink>
          </Menu.Item>
        ))}
      </Menu>
    </>
  )

  if (isMobile) {
    return (
      <Drawer
        placement="left"
        onClose={onMobileClose}
        visible={mobileOpen}
        width={280}
        bodyStyle={{ padding: 0, background: 'hsl(210, 55%, 22%)', height: '100%' }}
        style={{ zIndex: 1050 }}
      >
        {menuContent}
      </Drawer>
    )
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      breakpoint="lg"
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        background: 'hsl(210, 55%, 22%)'
      }}
      theme="dark"
    >
      {menuContent}
    </Sider>
  )
}

export default SideNav
